<template>
  <div>
    <div
      class="xccy"
      id="download"
      :style="{ background: 'url(' + require('@/assets/images/chanpin/xccy_bg.png') + ') no-repeat center center'}"
    >
      <!-- <div @click="downloadWord">下载产品介绍</div> -->
      <el-tooltip class="item" effect="dark" content="为了更好地为您服务，请首先填写商务合作申请，谢谢" placement="top">
        <div class="gotodownload" @click="downloadWord">下载产品介绍</div>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
// import { BaseURL } from '@/api/http.js'
export default {
  props: {
    product: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    downloadWord () {
      // const url = BaseURL + 'materials/downloadByName?typeName=' + this.product
      // window.open(url)
    }
  }
}
</script>

<style scoped>
.xccy {
  width: 100%;
  height: 240px;
  margin-bottom: 30px;
  background-color: white;
  position: relative;
}

.xccy div {
  width: 210px;
  line-height: 64px;
  background: linear-gradient(
    86deg,
    rgba(116, 96, 238, 1) 0%,
    rgba(252, 72, 122, 1) 100%
  );
  border-radius: 4px;
  font-size: 22px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -105px;
  margin-top: -35px;
  filter: "progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(116, 96, 238, 1), endColorstr=rgba(252, 72, 122, 1))";
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient (GradientType=1, startColorstr=#7460EE, endColorstr=#FC487A)";
}
</style>



// WEBPACK FOOTER //
// src/components/common/productDownload.vue